import { resolveProviderPixelIds } from "@next-platform/packages-ts-types";
import { useApp } from "@next-platform/client-common-core";

import useAdvancedMatching from "@/features/tracking/advancedMatching/useAdvancedMatching";
import { useMetaPixel } from "@/features/tracking/providers/meta/useMetaPixel";

/**
 * Root mount for every ad-platform browser pixel.
 *
 * Lives alongside `AttributionTracking` in `app.tsx` so pixels load
 * with the same lifecycle as attribution capture (one instance per
 * page load, after the app-config fetch has resolved).
 *
 * Each provider's hook is invoked unconditionally (rules of hooks)
 * and internally no-ops when its id is absent — keeps the provider
 * list flat and additive: wiring TikTok / Snap / Reddit is one extra
 * line here plus one new hook file.
 */
const TrackingPixels = (): null => {
  const { appSettings } = useApp();
  const advancedMatching = useAdvancedMatching();
  const metaDatasetIds = resolveProviderPixelIds(appSettings?.trackingPixels?.meta);

  useMetaPixel({ datasetIds: metaDatasetIds, matching: advancedMatching });

  return null;
};

export default TrackingPixels;
